import { ExternalLink } from "lucide-react";
import { openOnWebsite } from "@/lib/platform";

export default function WebsiteOnlyNotice({ what = "Memberships and donations", path = "/", testId = "ios-website-notice" }) {
  return (
    <div data-testid={testId} className="bg-black/40 border border-white/15 p-4 space-y-3">
      <p className="text-sm text-gray-300 leading-relaxed">
        {what} are handled on our website, not inside this app.
      </p>
      <button type="button" onClick={() => openOnWebsite(path)} data-testid={`${testId}-button`}
        className="inline-flex items-center gap-2 border border-white/25 hover:border-blood hover:text-blood font-display font-bold uppercase tracking-wider text-sm px-4 py-2 transition-colors">
        <ExternalLink size={14} /> Open zopound website
      </button>
    </div>
  );
}
